import { useLayoutEffect, useRef } from 'react'

import UIIcon, { UIIconType } from '@/components/UI/UIIcon'
import { useGSAP } from '@/composables/useGSAP'

const icons = ['circle', 'background3', 'triangle']
const colors = ['text-light-blue', 'text-mid-blue', 'text-coral']

type LoadingFooterItemProps = {
  index: number
  delay?: number
}

export default function LoadingFooterItem({ index, delay = 0 }: LoadingFooterItemProps) {
  const { gsap } = useGSAP()
  const svgRefs = useRef<SVGElement[]>([])

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      // gsap.timeline({ repeat: -1 })
      //   .fromTo(
      //     svgRefs.current,
      //     {
      //       scale: 0,
      //     },
      //     {
      //       scale: 1,
      //       duration: 0.3,
      //       stagger: 0.3,
      //       ease: "power3.out",
      //     },
      //     0
      //   )
      //   .fromTo(
      //     svgRefs.current,
      //     {
      //       opacity: 1,
      //     },
      //     {
      //       opacity: 0,
      //       duration: 0.3,
      //       stagger: 0.3,
      //       ease: "power3.out",
      //     },
      //     0.3
      //   )
      svgRefs.current.forEach((svg, svgIndex) => {
        gsap
          .timeline({ repeat: -1, delay: svgIndex * 0.9 + delay, repeatDelay: 1.8 })
          .set(svg, { zIndex: 1, immediateRender: false }, 0)
          .set(svg, { zIndex: 0, immediateRender: false }, 0.5)
          .fromTo(
            svg,
            {
              scale: 0.5,
              rotate: svgIndex % 2 === 0 ? -180 : 180,
            },
            {
              scale: 1,
              rotate: 0,
              duration: 0.8,
              ease: 'back.out(1.7)',
            },
            0
          )
          .fromTo(
            svg,
            {
              opacity: 0,
            },
            {
              opacity: 1,
              duration: 0.3,
              ease: 'power3.out',
            },
            0
          )
          .to(
            svg,
            {
              opacity: 0,
              duration: 0.3,
              ease: 'power1.in',
            },
            0.5
          )
      })
    })

    return () => ctx.kill()
  }, [gsap])

  return (
    <div className='grid'>
      <UIIcon
        ref={(ref) => {
          svgRefs.current[0] = ref
        }}
        icon={icons[(0 + index) % icons.length] as UIIconType}
        className={`${colors[(0 + index) % colors.length]} col-start-1 col-span-1 row-start-1 row-span-1 opacity-0`}
      />
      <UIIcon
        ref={(ref) => {
          svgRefs.current[1] = ref
        }}
        icon={icons[(1 + index) % icons.length] as UIIconType}
        className={`${colors[(1 + index) % colors.length]} col-start-1 col-span-1 row-start-1 row-span-1 opacity-0`}
      />
      <UIIcon
        ref={(ref) => {
          svgRefs.current[2] = ref
        }}
        icon={icons[(2 + index) % icons.length] as UIIconType}
        className={`${colors[(2 + index) % colors.length]} col-start-1 col-span-1 row-start-1 row-span-1 opacity-0`}
      />
    </div>
  )
}
